import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";

export const Error404 = () => {
  const navigate = useNavigate();

  return (
    <Container
      className="d-flex min-vh-100 align-items-center justify-content-center px-3"
      style={
        {
          // background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8ed 100%)"
        }
      }
    >
      <Row className="justify-content-center">
        <Col lg={8} className="text-center">
          <div className="mb-4">
            <svg
              width="120"
              height="120"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-danger"
            >
              <path
                d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h1 className="display-3 fw-bold text-dark mb-3">404</h1>
          <h2 className="h3 mb-3">Oops! Page Not Found</h2>
          <p className="lead text-muted mb-5 fw-medium">
            We can't seem to find the page you're looking for. It might have
            been removed, had its name changed, or is temporarily unavailable.
          </p>

          <div className="d-flex flex-wrap gap-3 justify-content-center">
            <Button
              className="fw-bold px-4 py-3"
              style={{
                background: "linear-gradient(to right, #FF5E43, #FB992E)",
                border: "none",
                borderRadius: "50px",
                minWidth: "200px",
              }}
              onClick={() => navigate("/")}
            >
              Go to Homepage
            </Button>

            <Button
              variant="outline-dark"
              className="fw-bold px-4 py-3"
              style={{
                borderRadius: "50px",
                minWidth: "200px",
              }}
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
          </div>

          <div className="mt-5">
            <h5 className="text-muted">
              Need help?{" "}
              <a
                href="/contact-us"
                className="text-decoration-none fw-bold"
                style={{
                  color: "#FF5E43",
                  transition: "all 0.3s ease",
                  borderBottom: "1px dashed currentColor",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#FB992E")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#FF5E43")}
              >
                Contact support
              </a>
            </h5>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
